import { Grid, Typography, Box, Paper } from "@mui/material";
import React from "react";
import { useLang } from "../../context/language.context";
// import Testimonial from "../../components/Testimonial";

const res = {
  title: ["מחירון טיפולים", "Price For Treatments"],
  subtitle: [
    "בחרו את הטיפול המתאים לכם וקבלו חוויית ריפוי מלאה",
    "Choose the session that fits you and enjoy a full healing experience",
  ],
};
const itemRes = [
  {
    title: ["שיאצו / שיאצו ודיקור", "Shiatsu / Shiatsu and Acupuncture"],
    description: [
      "טיפול שיאצו הכולל מתיחות והנעות מפרקים, עם אופציה לדיקור.",
      "Shiatsu session focusing on stretches and joint mobilizations. Acupuncture is optional.",
    ],
    tiers: [{ minutes: 60, price: 300 }],
  },
  {
    title: ["עיסוי משולב", "Massage"],
    description: [
      "טיפול המשלב טכניקות שונות של עיסוי שוודי, רקמות עמוקות, שיאצו ועוד.",
      "A session blending Swedish, deep-tissue, shiatsu, and additional massage techniques.",
    ],
    note: [
      "*בעל ניסיון רב בטיפול בכאבים אורתופדיים",
      "*Extensive experience treating orthopedic pain",
    ],
    tiers: [
      { minutes: 70, price: 320 },
      { minutes: 90, price: 400 },
    ],
  },
  {
    title: ["טיפול עד הבית", "Home Treatment"],
    description: [
      "אגיע אליכם עם הציוד הנדרש לחוויית טיפול מקצועית ומדויקת בשבילכם.",
      "Enjoy a private treatment experience in the comfort of your own home, with a personalized session tailored to your needs and all equipment provided.",
    ],
    tiers: [
      { minutes: 75, price: 400 },
      { minutes: 90, price: 450 },
    ],
  },
];

export default function Prices() {
  const { language } = useLang();
  const currency = language ? "NIS" : 'ש"ח';
  const isEnglish = Boolean(language);
  const localeIndex = Number(language);

  const capitalizeLine = (text) => {
    if (!text) return text;
    if (isEnglish) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    }
    return text;
  };

  return (
    <Grid container justifyContent={"center"} minHeight={"100vh"}>
      <Grid
        container
        sx={{
          maxWidth: "2100px",
          width: "100%",
          mx: "auto",
          px: { xs: 2, sm: 3, md: 4 },
          py: { xs: 4, md: 6 },
        }}
        rowSpacing={{ xs: 3, md: 3 }}
      >
        <Grid
          item
          container
          justifyContent={"center"}
          alignItems={"center"}
          sx={{ mt: { xs: 1, md: 2 } }}
        >
          <Typography
            variant="h2"
            align={"center"}
            textAlign={"center"}
            alignContent={"center"}
            justifyContent={"center"}
            sx={{
              p: 1.5,
              display: "flex",
              fontFamily: "Amatic SC",
              fontWeight: 700,
              color: "inherit",
              textDecoration: "none",
              fontSize: "clamp(1.8rem, 2.2vw, 2.3rem)",
            }}
          >
            {capitalizeLine(res.title[localeIndex])}
          </Typography>
        </Grid>

        <Grid item container spacing={{ xs: 2, sm: 2.5, md: 3 }}>
          {itemRes.map((item, index) => {
            const localizedTitle = capitalizeLine(item.title[localeIndex]);
            const localizedDescription = capitalizeLine(
              item.description[localeIndex]
            );
            return (
              <Grid key={index}  item xs={12} sm={6} sx={{overflow:'hidden'}}>
                <Paper
                  elevation={2}
                  sx={{
                    height: "80%",
                    p: { xs: 2.5, sm: 2.7, md: 3 },
                    borderRadius: 4,
                    position: "relative",
                    overflow: "hidden",
                    display: "flex",
                    // mb: 5,
                    flexDirection: "column",
                    gap: 1.5,
                    background: "linear-gradient(165deg, #ffffff 0%, #f4f7f4 100%)",
                    boxShadow: "0 16px 32px -20px rgba(31, 64, 38, 0.5)",
                    border: "1px solid rgba(64, 112, 77, 0.08)",
                    transition: "transform 240ms ease, box-shadow 240ms ease",
                    textAlign: isEnglish ? "left" : "right",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: "0 26px 45px -20px rgba(31, 64, 38, 0.6)",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Amatic SC",
                      fontSize: "clamp(1.6rem, 2.2vw, 2rem)",
                      fontWeight: 700,
                      color: "#2f5232",
                      letterSpacing: isEnglish ? "0.04em" : 0,
                    }}
                  >
                    {localizedTitle}
                  </Typography>
                  <Typography
                    sx={{
                      flexGrow: 1,
                      color: "#4f5d4c",
                      fontSize: "clamp(0.9rem, 1.7vw, 1.05rem)",
                      lineHeight: 1.6,
                    }}
                  >
                    {localizedDescription}
                  </Typography>
                  {item.note && (
                    <Typography
                      sx={{
                        color: "#7a8a76",
                        fontStyle: "italic",
                        fontSize: "clamp(0.8rem, 1.5vw, 0.95rem)",
                        lineHeight: 1.5,
                      }}
                    >
                      {item.note[localeIndex]}
                    </Typography>
                  )}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                      alignItems: isEnglish ? "flex-start" : "flex-end",
                      mt: 1,
                      pb: 5,
                    }}
                  >
                    {item.tiers.map((tier, tierIndex) => (
                      <Box
                        key={tierIndex}
                        sx={{
                          display: "flex",
                          flexDirection: isEnglish ? "row" : "row-reverse",
                          alignItems: "baseline",
                          gap: 1.5,
                        }}
                      >
                        <Typography
                          sx={{
                            color: "#7a8a76",
                            fontWeight: 500,
                            fontSize: "clamp(0.85rem, 1.6vw, 1rem)",
                          }}
                        >
                          {isEnglish
                            ? `Approximately ${tier.minutes} minutes`
                            : `${tier.minutes} דק'`}
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: isEnglish ? "row" : "row-reverse",
                            alignItems: "baseline",
                            gap: 0.75,
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 700,
                              color: "#2f5232",
                              fontSize: "clamp(1.25rem, 2.4vw, 1.6rem)",
                            }}
                          >
                            {tier.price}
                          </Typography>
                          <Typography
                            sx={{
                              fontWeight: 600,
                              color: "#7a8a76",
                              fontSize: "clamp(0.85rem, 1.6vw, 1rem)",
                              textTransform: "uppercase",
                              letterSpacing: "0.08em",
                            }}
                          >
                            {currency}
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                </Paper>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
      {/* <Grid container justifyContent={"flex-end"} sx={{ padding: 5 }}>
        <Grid container justifyContent={"flex-end"}>
          בעקבות המצב *
        </Grid>
        <Grid container justifyContent={"flex-end"}>
          לתושבי העוטף ונפגעי נובה{" "}
        </Grid>
        <Grid>הטיפול ללא עלות, או כראות עינכם</Grid>
      </Grid> */}
    </Grid>
  );
}
